import React from "react";
import AddGiftCardForm from "./AddGiftCardForm";
import MainPageCompenent from './MainPageCompenent';
function CustomerRepresenterAdd(props) {
    return (
        <MainPageCompenent>
            <AddGiftCardForm/>
        </MainPageCompenent>
    );
}

export default CustomerRepresenterAdd;